module.exports = __webpack_public_path__ + "static/media/clap.e2b234dd.ogg";